var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    fill: "#EDF2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1751 96.1606L77.0042 76.229L73.01 80.2711L93.181 100.203L97.1751 96.1606Z",
    fill: "#CEDBF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.88 101.516L89.1873 86.0094C89.0999 85.923 88.9591 85.9239 88.8727 86.0112L82.933 92.0223C82.8467 92.1096 82.8475 92.2505 82.9349 92.3368L98.628 107.844C98.7153 107.93 98.8562 107.929 98.9425 107.842L104.882 101.831C104.969 101.743 104.968 101.603 104.88 101.516Z",
    fill: "#B4C2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1265 86.2531C73.0035 86.2531 84.2531 75.0035 84.2531 61.1265C84.2531 47.2495 73.0035 36 59.1265 36C45.2495 36 34 47.2495 34 61.1265C34 75.0035 45.2495 86.2531 59.1265 86.2531Z",
    fill: "#B4C2E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1265 82.1534C70.7392 82.1534 80.1532 72.7395 80.1532 61.1268C80.1532 49.5141 70.7392 40.1001 59.1265 40.1001C47.5138 40.1001 38.0999 49.5141 38.0999 61.1268C38.0999 72.7395 47.5138 82.1534 59.1265 82.1534Z",
    fill: "#EDF2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSearch);
export default __webpack_public_path__ + "static/media/empty_state_search.d67318932d08fcf350573f84c450a02e.svg";
export { ForwardRef as ReactComponent };